<template>
    <div class="uk-section">
      <div class="uk-container uk-container-small">
        <h2>Registrer ny bruker</h2>
      <form @submit.prevent="onSubmit">
        <div class="input">
          <label for="email">E-postadresse</label>
          <input
                  type="email"
                  id="email"
                  v-model="email">
        </div>
        <div class="input">
          <label for="username">Brukernavn</label>
          <input
                  type="text"
                  id="username"
                  v-model="username">
        </div>
        <div class="input">
          <label for="age">Ditt navn</label>
          <input
                  type="text"
                  id="name"
                  v-model="name">
        </div>
        <div class="input">
          <label for="password">Passord</label>
          <input
                  type="password"
                  id="password"
                  v-model="password">
        </div>
        
        <div class="submit">
          <button type="submit">Registrer bruker</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router.js'
  export default {
    data () {
      return {
        email: '',
        username: '',
        name: '',
        password: ''
      }
    },
    methods: {
      onSubmit () {
        const formData = {
          email: this.email,
          username: this.username,
          name: this.name,
          password: this.password,
        }
      axios.post('http://localhost:1337/users', {
        email: formData.email,
        username: formData.username,
        name: formData.name,
        password: formData.password
      })
        .then(res => {
          console.log("Simen: "+res)
          router.push("/login")
        })
        .catch(error => console.log(error))
        console.log(formData)
      }
    }
  }
</script>

<style scoped>
  .signup-form {
    width: 320px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }
  .input {
    margin: 10px auto;
  }
  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }
  .input.inline label {
    display: inline;
  }
  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border-radius: 7px; 
    border: 1px solid #c3cc;
  }
  .input.inline input {
    width: auto;
  }
  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }
  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }
  .hobbies button {
    border: 1px solid #521751;
    background: #521751;
    color: white;
    padding: 6px;
    font: inherit;
    cursor: pointer;
  }
  .hobbies button:hover,
  .hobbies button:active {
    background-color: #8d4288;
  }
  .hobbies input {
    width: 90%;
  }
  .submit button {
    border-radius: 18px;
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
  }
  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
    
  }
  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
</style>